// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"d5-z","refreshPageWarning":"e5-z","redirectMessageText":"f5-z"};